// @ts-nocheck
import React from "react";
import { hexToCSSFilter } from "hex-to-css-filter";
import { FILES_URL } from "includes/paths";
import "./ReactionIcon.css";
import { useQuery } from "react-query";
import genRequest from "includes/request";

export default function ReactionIcon(props) {
	const reactionId = props.id;
	// Refetch from API only when async + id is provided. The previous
	// onSuccess body assigned to outer-scope locals during render — that
	// did nothing useful (overwritten below) and caused subtle re-render
	// bugs, so it's been dropped.
	const { data } = useQuery(
		["reactions", reactionId],
		() => genRequest("reactions/" + reactionId),
		{ enabled: !!(props.async && reactionId) },
	);

	if (props.async && !data) return false;

	const src = data || props;
	// v2 reactions are emoji-based: API returns `{ id, name: "👍", value: "thumbsup" }`
	// with no iconUrl. Earlier component blindly built `${FILES_URL}${src.iconUrl}`
	// which produced `/onlyall-files/undefined` → 404 on every render. Render the
	// emoji from `name` when no iconUrl is set; fall back to the legacy
	// custom-icon image only when one actually exists.
	const hasIconUrl =
		typeof src.iconUrl === "string" && src.iconUrl.length > 0;
	const hexFilter = src.hexaColor ? hexToCSSFilter(src.hexaColor) : null;

	return (
		<div
			className={
				"ReactionIcon" + (props.className ? " " + props.className : "")
			}
			title={src.description || src.name}
			alt={src.description || src.name}
			style={props.style}
		>
			{hasIconUrl ? (
				<img
					className={props.iconClasses}
					loading="lazy"
					draggable={false}
					src={FILES_URL + src.iconUrl}
					style={{
						filter: hexFilter?.filter.replace(";", ""),
					}}
					alt={src.description || src.name}
				/>
			) : (
				<span
					className={
						"reaction-emoji" +
						(props.iconClasses ? " " + props.iconClasses : "")
					}
					aria-label={src.description || src.name}
				>
					{src.name}
				</span>
			)}
		</div>
	);
}
